/*
 * Kadenze.NotificationCenterViewModel
 *
 * A notification center view model is responsible for containing lists and other child view models
 *
 * @params: Object
 *   @parentObject {String} - jQuery selector of the node to insert the notification center template into
 *   @template {String} - JST valid path to a template
 *   @identifierClass {String} - class the identifies the template markup, see 'javascripts/templates/notification-center' for an example
 *   @contentContainer {String}  - jQuery selector of the container that will hold its child lists
 *   @offsetTopAdjustment {Integer} - How much to offset the windows position, its' position is calculated based on its' window trigger, this adds to that offset
 *   @offsetRightAdjustment {Integer} - How much to offset the windows right position
 *   @windowTrigger: {Object} - The node that should open / close / trigger the notification center
 *   @listData: {Array} - Array of lists that follow the Kadenze.NotificationList format
*/
import NotificationList from 'libs/components/notifications/list';

export default function(params, $el) {
  var self = this;

  self.defaults = {
    parentObject: '#main',
    template: 'templates/notification-center',
    identifierClass: '.notification-center',
    contentContainer: '.notification-center__content',
    offsetTopAdjustment: -10,
    offsetRightAdjustment: 60,
    windowTrigger: null,
    drawMiniCalendar: false,
    listData: []
  };

  self.config = $.extend(true, {}, self.defaults, params);

  self.isVisible = ko.observable(false);
  self.isActive = ko.observable(false);
  self.template = $(JST[self.config.template]())[0];
  self.$parentObject = $(self.config.parentObject);
  self.animateProps = ko.observable();
  self.itemLists = ko.observableArray();
  self.calendarEventList = ko.observableArray();

  self.UUID = ko.computed(function() {
    return Kadenze.Util.UUID();
  });

  // Calculate the window position based off of windowTrigger, can be adjusted
  // via the offset adjustment in self.config
  self.position = ko.computed(function() {
    var $el = $(self.config.windowTrigger),
      offsetRight = Kadenze.Util.offsetRight(self.config.windowTrigger) - self.config.offsetRightAdjustment,
      offsetTop = ($el.offset().top + $el.outerHeight()) + self.config.offsetTopAdjustment;

    return {
      right: offsetRight + 'px',
      top: offsetTop,
      opacity: 0
    };
  });

  self.init = function() {
    // Insert the template
    self.render();

    // Build a list of Kadenze.NotificationList view models
    self.buildList(self.config.listData);

    // Apply bindings to inserted template
    ko.applyBindings(self, self.template);

    // Render the mini-calendar
    self.initMiniCalendar();
  };

  self.initMiniCalendar = function(){
    if (self.config.drawMiniCalendar && self.config.listData[0].title === 'today'){
      var url = Kadenze.Routes.calendar_events_path();
      var request = new Kadenze.AjaxRequest({
        url: url,
        type: 'GET',
        format: 'json',
      });
      // self.loading(true);
      // self.itemLists()[0].loading(true);
      // Kadenze.UIUtil.showLoadingIndicator(self.$el);
      request.done(function(data) {
        self.allCalendarEvents = data.events;
        self.setCalendarEventList();
        var $templates = $(data.calendar_template_html);
        var clndrTemplate = $templates.find('#js-clndr-template').text();
        // self.itemLists()[0].loading(false);
        self.clndr = $('#js-topnav-calendar-container').clndr({
          events: data.events,
          template: clndrTemplate,
          multiDayEvents: {
            endDate: 'end',
            startDate: 'start'
          },
          daysOfTheWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          trackSelectedDate: true,
          selectedDate: new Date(),
          clickEvents: {
            click: function (target) {
              self.setCalendarEventList(target.date);
              console.log(target.date.format());
            },
            onMonthChange: function (monthDate) {
              self.setCalendarEventList(monthDate);
              console.log(monthDate.format());
            }
          },
        });
      });
      request.complete(function() {
        // self.loading(false);
        // Kadenze.UIUtil.hideLoadingIndicator(self.$el);
      });
    }
  };

  self.buildList = function(listItems, shouldReset) {
    var params = {
      windowId: self.UUID(),
      hasSibling: self.config.listData.length > 1,
      seeAllUrl: '/notifications',
      calendarUrl: Kadenze.Routes.user_calendar_path(),
      messengerUrl: Kadenze.Routes.messenger_overview_path(),
      parentVM: self
    };

    if(shouldReset) {
      self.itemLists.removeAll();
    }

    // If there's more than one and the window isn't open, determine their order
    if(!self.isActive() && params.hasSibling) {
      listItems = self.determinListOrder(listItems);
    }

    _.each(listItems, function(item) {
      self.itemLists.push(new NotificationList(_.extend(params, item)));
    });

    self.tallyAllFreshItems();
  };

  // Determine what list should be displayed first based on:
  //  - If the list has fresh items
  //  - If the list has items at all
  //  - In a tie, the first list is chosen
  self.determinListOrder = function(lists) {
    var bothTrue, bothFalse;

    let freshCheck = _.map(lists, function(item) {
      if(item.fresh_count > 0) {
        item.isFirst = true;
      } else if(item.count > 0) {
        item.isFirst = true;
      } else {
        item.isFirst = false;
      }
      return item;
    });

    bothTrue = _.where(freshCheck, { isFirst: true }).length > 1;
    bothFalse = _.where(freshCheck, { isFirst: false }).length > 1;

    if(bothTrue) {
      freshCheck[1].isFirst = false;
    } else if(bothFalse) {
      freshCheck[0].isFirst = true;
    }

    return freshCheck;
  };

  // Tallies the fresh items of all of the child lists
  self.tallyAllFreshItems = function() {
    var tally = _.map(self.itemLists(), function(list, i) { return list.freshCount(); }),
      total = _.reduce(tally, function(a, b) { return a + b; }),
      $badge = $(self.config.windowTrigger).find('.kd-badge');

    if(total > 0) {
      $badge.text(total);
      $badge.show();
    } else {
      $badge.hide();
    }
  };

  // Insert into the first matched parent only
  self.render = function() {
    self.$el = self.$parentObject.first().prepend(self.template);
  };

  // Toggle visibility of the window
  self.toggle = function() {
    if(!self.isVisible()) {
      self.show();
    } else {
      self.hide();
    }
  };

  // Shows the window, anything set in self.animateProps will be animated
  self.show = function() {
    self.isVisible(true);

    $(self.config.windowTrigger).attr('aria-expanded', 'true');

    // Truncate text
    $('.notification .js-dotdotdot').dotdotdot();

    self.animateProps({ top: self.position().top + 10, opacity: 1, ease: Quint.easeOut, onComplete: self.afterShow });
    // hide notification dropdown when user presses esc key
    $(document).off('keyup.notification_center').on('keyup.notification_center', function(event) {
      if(event.which == 27){
        self.hide();
      }
    });
  };

  // Called after the show animation completes
  self.afterShow = function() {
    self.isActive(true);

    var tab = self.getTab('active');
    if ($(self.template).find('.notification-center__tab.notification-center__tab--active').length > 0) {
      $(self.template).find('.notification-center__tab.notification-center__tab--active').focus();
    } else if ($(self.template).find('.notification-center__header.notification-center__header--active').length > 0) {
      $(self.template).find('.notification-center__header.notification-center__header--active').focus();
    }
    tab.updateFreshCount();
    tab.watchScroll();
    self.watchFreshItems(self.config.contentContainer, tab);
  };

  // Hides the window, anything set in self.animateProps will be animated
  self.hide = function() {
    $(self.config.windowTrigger).attr('aria-expanded', 'false');
    self.animateProps({ top: self.position().top, opacity: 0, ease: Quint.easeOut, onComplete: self.afterHide });
  };

  // Called after the hide animation completes
  self.afterHide = function() {
    self.isVisible(false);
    self.isActive(false);
  };

  // If there are tabs, this will show / hide each appropriately, a tab / list
  // view model should be passed in
  self.toggleTab = function(tab) {
    var activeTab = self.getTab('active'),
      inactiveTab = self.getTab('inactive');

    if(tab.UUID() !== activeTab.UUID()) {
      inactiveTab.isActive(true);
      activeTab.isActive(false);
      self.onTabChange.call(self, tab);
    }
  };

  // Get the active or inactive tab / list
  self.getTab = function(type) {
    return ko.utils.arrayFirst(self.itemLists(), function(list) {
      return type === 'active' ? list.isActive() : !list.isActive();
    });
  };

  // Called when tabs / lists are changed
  self.onTabChange = function(tab) {
    tab.watchScroll();
    tab.updateFreshCount();
    self.watchFreshItems(self.config.contentContainer, tab);
  };

  // de bounced scroll event to check / update when items have been 'seen'
  self.watchFreshItems = function(container, tab) {
    var debounced = _.debounce(tab.updateFreshCount, 1000);
    $(container).off('scroll.fresh').on('scroll.fresh', debounced);
  };

  self.setCalendarEventList = function(selectedDate) {
    if (!selectedDate) {
      selectedDate = moment().startOf('day');
    }
    var selectedEvents = _.chain(self.allCalendarEvents)
      .filter(function(event){
        event.startDate = new Date(event.start);
        return moment(event.startDate).startOf('day').isSame(selectedDate);
      })
      .uniq('id')
      .sortBy(function(event) {
        return event.startDate.getTime();
      })
      .map(function(event){
        var start = moment(event.start);
        event.startTime = start.format('h:mm a');
        return event;
      }).value();
    var selectedCalendarEvents = {
      date: selectedDate.format('dddd, MMMM D YYYY'),
      events: selectedEvents
    };
    self.itemLists()[0].selectedCalendarEvents(selectedCalendarEvents);
  };

  self.init();

  return self;
}